import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ISendAgentRegistrationEmailClient,
} from 'interfaceAdapter/gatewaySchemas/ISendAgentRegistrationEmailClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/send_registration_email`;

export class SendAgentRegistrationEmailClient implements ISendAgentRegistrationEmailClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { email } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({
            email,
        });
        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
